/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegexPasswordValidationRule } from './RegexPasswordValidationRule';
import {
    RegexPasswordValidationRuleFromJSON,
    RegexPasswordValidationRuleFromJSONTyped,
    RegexPasswordValidationRuleToJSON,
    RegexPasswordValidationRuleToJSONTyped,
} from './RegexPasswordValidationRule';

/**
 * 
 * @export
 * @interface PasswordValidationRuleset
 */
export interface PasswordValidationRuleset {
    /**
     * 
     * @type {Array<RegexPasswordValidationRule>}
     * @memberof PasswordValidationRuleset
     */
    regular_expressions?: Array<RegexPasswordValidationRule>;
}

/**
 * Check if a given object implements the PasswordValidationRuleset interface.
 */
export function instanceOfPasswordValidationRuleset(value: object): value is PasswordValidationRuleset {
    return true;
}

export function PasswordValidationRulesetFromJSON(json: any): PasswordValidationRuleset {
    return PasswordValidationRulesetFromJSONTyped(json, false);
}

export function PasswordValidationRulesetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordValidationRuleset {
    if (json == null) {
        return json;
    }
    return {
        
        'regular_expressions': json['regular_expressions'] == null ? undefined : ((json['regular_expressions'] as Array<any>).map(RegexPasswordValidationRuleFromJSON)),
    };
}

export function PasswordValidationRulesetToJSON(json: any): PasswordValidationRuleset {
    return PasswordValidationRulesetToJSONTyped(json, false);
}

export function PasswordValidationRulesetToJSONTyped(value?: PasswordValidationRuleset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regular_expressions': value['regular_expressions'] == null ? undefined : ((value['regular_expressions'] as Array<any>).map(RegexPasswordValidationRuleToJSON)),
    };
}

